export default __webpack_public_path__ + "static/gonville-caius-cambridge-2ecff3cd2c5cea69fc1751f451be7698.png";